import { request } from '@/shared/api/request'

export const sendSignedStaff = ({data, params}) => {
	return request({ url: 'staff/xml/send', method: 'POST', data: data, params })
}
